const MyInformationSourceEnum = {
  Registration: 'Registration',
  ManuallyCreated: 'Manually created',
};
export default Object.freeze(MyInformationSourceEnum);
